import React from 'react';
import { Navigate } from 'react-router-dom';
import EmployeeDashboard from '../pages/Dashboard/EmployeeDashboard';
import ResellerDashboard from '../pages/Dashboard/ResellerDashboard';
import AdminDashboard from '../pages/Dashboard/AdminDashboard';

function DashboardRouter({ user }) {

  if (!user) {
    return <Navigate to="/" replace />;
  }

  const handleReturnToLogin = () => {
    localStorage.removeItem('googleLoggedIn');
    localStorage.removeItem('userRole');
    window.location.href = '/';
  };

  switch (user.role) {
    case 'employee':
      return <EmployeeDashboard user={user} />;
    case 'reseller':
      return <ResellerDashboard user={user} />;
    case 'admin':
      return <AdminDashboard user={user} />;
    default:
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Unknown role</h2>
          <p>Please contact support. (Role: {user.role})</p>
          <button onClick={handleReturnToLogin} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '1rem' }}>
            Return to Login
          </button>
        </div>
      );
  }
}

export default DashboardRouter;
